module.exports = __webpack_public_path__ + "img/ic_launcher_3.7ba82d46.png";